<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Novo Vídeo</h2>
            </div>
            <form-video />
        </div>
    </div>
</template>

<script>
    import FormVideo from './form-video'
    export default {
        components: { FormVideo },
        name: "novo-video",
        data() {
            return {}
        }
    }
</script>
